import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/icon/icon-web-default.svg';
import _imports_1 from '@/assets/icon/icon-web-primary.svg';
import _imports_2 from '@/assets/icon/icon-discord-default.svg';
import _imports_3 from '@/assets/icon/icon-discord-primary.svg';
import _imports_4 from '@/assets/icon/icon-twitter-default.svg';
import _imports_5 from '@/assets/icon/icon-twitter-primary.svg';
import _imports_6 from '@/assets/icon/icon-ig-default.svg';
import _imports_7 from '@/assets/icon/icon-ig-primary.svg';

const _withScopeId = n => (_pushScopeId("data-v-572fd6d0"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "collection-header"
};
const _hoisted_2 = {
  class: "collection-info-container"
};

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "profile-picture-badge"
}, null, -1));

const _hoisted_4 = {
  class: "external-links-wrapper"
};

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "normal",
  src: _imports_0,
  alt: "web"
}, null, -1));

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "hover",
  src: _imports_1,
  alt: "web"
}, null, -1));

const _hoisted_7 = [_hoisted_5, _hoisted_6];

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "normal",
  src: _imports_2,
  alt: "discord"
}, null, -1));

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "hover",
  src: _imports_3,
  alt: "discord"
}, null, -1));

const _hoisted_10 = [_hoisted_8, _hoisted_9];

const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "normal",
  src: _imports_4,
  alt: "twitter"
}, null, -1));

const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "hover",
  src: _imports_5,
  alt: "twitter"
}, null, -1));

const _hoisted_13 = [_hoisted_11, _hoisted_12];

const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "normal",
  src: _imports_6,
  alt: "ig"
}, null, -1));

const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "hover",
  src: _imports_7,
  alt: "ig"
}, null, -1));

const _hoisted_16 = [_hoisted_14, _hoisted_15];
const _hoisted_17 = {
  class: "font-subtitle1 title"
};
const _hoisted_18 = ["onClick"];

const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "font-display7"
}, "Open mint page", -1));

const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "btn-arrow"
}, null, -1));

const _hoisted_21 = [_hoisted_19, _hoisted_20];
const _hoisted_22 = ["innerHTML"];

const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "font-button1 text"
}, "Read More", -1));

const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "chevron"
}, null, -1));

const _hoisted_25 = [_hoisted_23, _hoisted_24];
const _hoisted_26 = {
  class: "statistics-container"
};
const _hoisted_27 = {
  class: "block"
};
const _hoisted_28 = {
  class: "font-h4 value"
};

const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "subtitle1 unit"
}, "Items", -1));

const _hoisted_30 = {
  class: "block"
};
const _hoisted_31 = {
  class: "font-h4 value"
};

const _hoisted_32 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "subtitle1 unit"
}, "Owners", -1));

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_icon_rounded = _resolveComponent("icon-rounded");

  const _component_router_link = _resolveComponent("router-link");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: "banner-container",
    style: _normalizeStyle(`background-image: url(${$props.info.banner})`)
  }, null, 4), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
    class: "profile-picture",
    style: _normalizeStyle(`background-image: url(${$props.info.profile})`)
  }, null, 4), _hoisted_3, _createElementVNode("div", _hoisted_4, [$props.info.links.web ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    onClick: _cache[0] || (_cache[0] = $event => $options.externalLink($props.info.links.web)),
    class: "icon-rounded-wrapper"
  }, _hoisted_7)) : _createCommentVNode("", true), $props.info.links.discord ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    onClick: _cache[1] || (_cache[1] = $event => $options.externalLink($props.info.links.discord)),
    class: "icon-rounded-wrapper"
  }, _hoisted_10)) : _createCommentVNode("", true), $props.info.links.twitter ? (_openBlock(), _createElementBlock("div", {
    key: 2,
    onClick: _cache[2] || (_cache[2] = $event => $options.externalLink($props.info.links.twitter)),
    class: "icon-rounded-wrapper"
  }, _hoisted_13)) : _createCommentVNode("", true), $props.info.links.ig ? (_openBlock(), _createElementBlock("div", {
    key: 3,
    onClick: _cache[3] || (_cache[3] = $event => $options.externalLink($props.info.links.ig)),
    class: "icon-rounded-wrapper"
  }, _hoisted_16)) : _createCommentVNode("", true), _createVNode(_component_icon_rounded, {
    link: $props.info.links.email,
    type: "email",
    images: $setup.emailImages,
    tipText: "email copied"
  }, null, 8, ["link", "images"])]), _createElementVNode("p", _hoisted_17, _toDisplayString($props.info.title), 1), $props.minting ? (_openBlock(), _createBlock(_component_router_link, {
    key: 0,
    custom: "",
    to: {
      name: 'CollectionMinting',
      params: {
        chain: $props.chain,
        collection: $props.collection
      }
    }
  }, {
    default: _withCtx(({
      navigate
    }) => [_createElementVNode("button", {
      class: "btn apply",
      onClick: navigate
    }, _hoisted_21, 8, _hoisted_18)]),
    _: 1
  }, 8, ["to"])) : _createCommentVNode("", true), $props.info.desc ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: _normalizeClass(["description-container", {
      expand: $data.isExpand
    }])
  }, [_createElementVNode("p", {
    class: "font-body2 desc",
    innerHTML: $props.info.desc
  }, null, 8, _hoisted_22), $props.info.desc.length > 300 ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "read-more-wrapper",
    onClick: _cache[4] || (_cache[4] = $event => $data.isExpand = !$data.isExpand)
  }, _hoisted_25)) : _createCommentVNode("", true)], 2)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, [_createElementVNode("span", _hoisted_28, _toDisplayString($props.info.items), 1), _hoisted_29]), _createElementVNode("div", _hoisted_30, [_createElementVNode("span", _hoisted_31, _toDisplayString($props.info.owners), 1), _hoisted_32])])])]);
}